<p-card>
  <h3 class="text-center" i18n>Modifier le plan du client</h3>

  <div class="flex flex-row gap-6 my-5">
    @if (hasWholeLife) {
      <em-whole-life-card
        class="w-full"
        (coverageSelected)="updateLifeInsurance($event, 'WHOLE')"
        [withProductSelection]="false"
        [selectedWholeLifeCoverageAmount]="selectedWholeLifeCoverageAmount"
        [selectedTermLifeCoverageAmount]="selectedTermLifeCoverageAmount"></em-whole-life-card>
    }
    @if (hasTermLife) {
      <em-term-life-card
        class="w-full"
        (coverageSelected)="updateLifeInsurance($event, 'TERM')"
        [withProductSelection]="false"
        [selectedTermLifeCoverageAmount]="selectedTermLifeCoverageAmount"
        [selectedWholeLifeCoverageAmount]="selectedWholeLifeCoverageAmount"></em-term-life-card>
    }
    @if (hasChildRider) {
      <em-child-rider-card
        class="w-full"
        (coverageSelected)="updateRider($event)"
        [ratesVersion]="ratesVersion"
        [selectedRiderCoverageAmount]="selectedChildRiderCoverageAmount"
        [selectedLifeInsuranceCoverageAmount]="
          (selectedWholeLifeCoverageAmount ?? 0) + (selectedTermLifeCoverageAmount ?? 0)
        "></em-child-rider-card>
    }
  </div>

  <em-selected-product-section [protection]="_selectedProtection"></em-selected-product-section>
</p-card>
